import Showdown from 'showdown'

const Converter = new Showdown.Converter()

const toHTML = (content) => (
  Converter.makeHtml(content)
)

export default toHTML
